import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import EditMessageModal from "../EditMessageModal";
import { REACT_APP_BACKEND_URL } from "../../config";

const MessageOptionsMenu = ({
	message,
	menuOpen,
	handleClose,
	anchorEl,
	disableEditDelete = false,
}) => {
	const { setReplyingMessage } = useContext(ReplyMessageContext);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [editModalOpen, setEditModalOpen] = useState(false);

	const handleDeleteMessage = async () => {
		try {
			await api.delete(`/messages/${message.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleEditMessage = async (newBody) => {
		try {
			await api.put(`/messages/${message.id}`, { body: newBody });
		} catch (err) {
			toastError(err);
		}
	};

	const hanldeReplyMessage = () => {
		setReplyingMessage(message);
		handleClose();
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenEditModal = e => {
		setEditModalOpen(true);
		handleClose();
	};

	const handleDownloadImage = () => {
		if (message.mediaUrl === null || !message.mediaUrl) return;
	  
		const imageUrl = message.mediaUrl;
		
		// Codificar la URL de Azure correctamente
		const encodedUrl = encodeURIComponent(imageUrl);
		const downloadUrl = `${REACT_APP_BACKEND_URL}/api/v1/public/download?url=${encodedUrl}`;
	  
		const link = document.createElement("a");
		link.href = downloadUrl; // Usar la URL del backend
		link.download = 'imagen.jpg';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	  };

	return (
		<>
			<ConfirmationModal
				title={i18n.t("messageOptionsMenu.confirmationModal.title")}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteMessage}
			>
				{i18n.t("messageOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<EditMessageModal
				open={editModalOpen}
				onClose={setEditModalOpen}
				onConfirm={handleEditMessage}
				initialValue={message.body}
			/>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<MenuItem onClick={hanldeReplyMessage}>
					{i18n.t("messageOptionsMenu.reply")}
				</MenuItem>
				{message.fromMe && !disableEditDelete && (
					<>
						<MenuItem onClick={handleOpenEditModal}>
							{i18n.t("messageOptionsMenu.edit")}
						</MenuItem>
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("messageOptionsMenu.delete")}
						</MenuItem>
					</>
				)}
				{message.mediaUrl && message.mediaType?.startsWith("image") && (
					<MenuItem onClick={handleDownloadImage}>
						{i18n.t("messageOptionsMenu.downloadImage")}
					</MenuItem>
				)}
			</Menu>
		</>
	);
};

export default MessageOptionsMenu;
